module.exports = __webpack_public_path__ + "img/IMG_0057_L_Foamcore.c77ce5d9.jpg";